import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const UPSERT_VIEWPORTS: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation upsertViewports($input: UpsertViewportsInput!) {
    upsertViewports(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
